import React from 'react';
import { CheckCircle2, ShieldCheck, Sparkles } from 'lucide-react';

const benefits = [
  'FREE demo class with a verified tutor',
  'Personalised learning plan for your child',
  'Adjustable within 7 days if the tutor isn\u2019t the right fit',
  'Priority WhatsApp support from our counsellors',
];

export default function RegistrationIntro() {
  return (
    <div className="lg:col-span-5">
      <span className="inline-flex items-center gap-2 bg-[#E64B2B] text-white px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-widest">
        <Sparkles size={12} /> Register today
      </span>
      <h2 className="mt-4 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
        One small step. <br className="hidden sm:block"/> A brighter <span className="text-[#E64B2B]">report card.</span>
      </h2>
      <div className="mt-4 inline-flex items-center gap-2 bg-[#4FB3B8] text-white px-3 py-1.5 rounded-md text-xs font-black uppercase tracking-widest border-2 border-[#2C3E50]">
        <Sparkles size={12} /> Demo class is 100% FREE
      </div>
      <p className="mt-5 text-[#2C3E50]/80 text-lg leading-relaxed">
        Book a <strong>FREE demo class</strong> with a verified tutor. No payment now, no card details &mdash; just share your requirements and we&rsquo;ll take care of the rest.
      </p>

      <ul className="mt-6 space-y-3">
        {benefits.map((b) => (
          <li key={b} className="flex items-start gap-3">
            <span className="mt-0.5 w-6 h-6 rounded-full bg-[#4FB3B8] text-white flex items-center justify-center shrink-0 border-2 border-[#2C3E50]">
              <CheckCircle2 size={14} strokeWidth={3} />
            </span>
            <span className="font-semibold text-[#2C3E50]">{b}</span>
          </li>
        ))}
      </ul>

      <div className="mt-6 inline-flex items-center gap-2 text-[#2C3E50]/75 text-sm font-bold">
        <ShieldCheck size={16} className="text-[#4FB3B8]" />
        Your details are safe with us &bull; We never spam
      </div>
    </div>
  );
}
